import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { AxiosError } from "axios";
import $api from "@/zapi-frontend/shared/api/axios";
import type { TUserPreferences } from "./useUserPreferences";

type UpdateUserPreferencesParams = {
  uiLanguage?: TUserPreferences["uiLanguage"];
};

export function useUpdateUserPreferences(
  options?: UseMutationOptions<TUserPreferences, AxiosError<{ message: string }>, UpdateUserPreferencesParams>
) {
  return useMutation({
    mutationKey: ["updateUserPreferences"],
    mutationFn: async (body: UpdateUserPreferencesParams) => {
      const response = await $api.patch<{ data: TUserPreferences; message: string }>("/user/preferences", body);
      return response.data.data;
    },
    ...options
  });
}
